import React, {useEffect, useState} from 'react';
import CartItem from '../components/CartItem';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { removeFromCart, updateQuantity, reduceQuantity } from '../store/cartSlice';
import { MdWhatsapp} from 'react-icons/md';

function Cart(){

   const api_url = "/api";

   const { cart } = useSelector(state => state.cart);
   const dispatch = useDispatch();
   let navigate = useNavigate(); 

   async function LogPage(){
       try{
      const response = await fetch(`${api_url}/views`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            name: "cart",
            view: "cartPage"
        }),
        });
      const data = await response.json();
      if(!response.ok){
        throw new Error(data.message || "Upload failed");
      }
      console.log(data)
     
       }catch(error){
         console.error("Failed to log view:", error);
       }
    }

    useEffect(()=>{
         LogPage()
       },[])

   const subtotal = cart.reduce((total,item) => total + (item.price * item.quantity),0)
   const totalItems = cart.reduce((total,item) => total + item.quantity,0)
   const discount = subtotal > 500 ? subtotal * 0.1 : 0
   const total = subtotal - discount

   const handleRemoveFromCart = (id, size) => {
      dispatch(removeFromCart({id,size}))
   }

   const handleIncreaseQuantity = (id, size) =>{
      dispatch(updateQuantity({id,size}))
   }

   const handleReduceQuantity = (id, size) =>{
      dispatch(reduceQuantity({id,size}))
   }
   
   return(
    <div className='flex one column'>
      <div className='flex one center'>
         <p className='bold special-font'>My Cart</p>
      </div>
      <div className='flex three overflow gap column'>
         {cart.length > 0 && (
            cart.map(el => {
               return(
                  <CartItem src={el.image} name={el.productName} price={el.price} size={el.size} quantity={el.quantity} id={el.id} removeFromCart={handleRemoveFromCart} updateQuantity={handleIncreaseQuantity} reduceQuantity={handleReduceQuantity}/>
               )
            })
         )}
      </div>
      <div className='flex three column top-shadow'>
         <div className='flex two'></div>
         <div className='flex one'>
            <div className='flex one center'>
               <span>Sub-total:</span>
            </div>
            <div className='flex one center'>
               <span className='bold'>ZMW {subtotal}</span>
            </div>
         </div>
         <div className='flex one'>
            <div className='flex one center'>
               <span>Discount:</span>
            </div>
            <div className='flex one center'>
               <span className='bold'>- ZMW {discount}</span>
            </div>
         </div>
          <div className='flex one'>
            <div className='flex one center'>
               <span>Total:</span>
            </div>
            <div className='flex one center'>
               <span className='bold'>ZMW {total}</span>
            </div>
         </div>
         <div className='flex one center'>
               <div className='add-cart-btn flex center orange' onClick={()=>{navigate(`/payment`, {state:{cartItems: cart, totalPrice: total, discount: discount, subtotal:subtotal}})}}>
                  <span className='white-txt'>Proceed to checkout</span>
               </div>
         </div>
          <div className='flex one center'>
                <div className='add-csrt-btn flex space-evenly center-align' onClick={()=>window.open('https://wa.me/260973666651', '_blank')}>
                     <span className='white-txt'>Contact Sales Rep on Whatsapp</span>
                     <MdWhatsapp size={25} className='white'/>
                </div>
         </div>
      </div>
    </div>
   )
}

export default Cart